import { firstValueFrom } from "rxjs";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable, SecurityContext } from "@angular/core";
import { environment as env } from "src/environments/environment";
import * as FileSaver from "file-saver";
import { map } from "rxjs/operators";
import { FormControl } from "@angular/forms";
import { CnpjValidator, CpfValidator } from "../utils/documento-validator";
import { Filial } from "src/app/refact/pages/components/sales/entities/interfacenet/filial";
import {
  ActivatedRoute,
  NavigationEnd,
  NavigationExtras,
  NavigationStart,
  Router,
} from "@angular/router";
import { Subject } from "rxjs";
import { Title } from "@angular/platform-browser";
import { ToastrService } from "ngx-toastr";

@Injectable({
  providedIn: "root",
})
export class UtilitiesService {
  //private readonly REPORT: string = 'http://desktop-dok1kss:16151/' + 'api/v1/Relatorio/crystal';
  private get REPORT(): string{
    return localStorage.getItem(env.baseApiModuleReportView.toString()) +
    "api/v1/Relatorio/crystal";
  }
  private readonly FILES: string =
    "http://app1.interfacenet.com.br:11607/api/v1/dashboard/fotos/INTERFACENET QLD.IN/01";
  private routeChangeSubject: Subject<string>;

  constructor(
    private _http: HttpClient,
    private router: Router,
    private route: ActivatedRoute,
    private title: Title,
    private toastService: ToastrService
  ) {
    this.routeChangeSubject = new Subject<string>();
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        this.routeChangeSubject.next(event.url);
      }
    });
  }

  pegaObservadorTrocaDeRota() {
    return this.routeChangeSubject.asObservable();
  }

  getPDF(recordSelectionFormula: string, arquivoRPT: string): void {
    const httpOptions = {
      responseType: "blob" as "json",
    };
    let params = {
      RecordSelectionFormula: recordSelectionFormula,
      ArquivoRPT: arquivoRPT,
    };
    this._http.post(this.REPORT, params, httpOptions).subscribe((data: any) => {
      var downloadURL = window.URL.createObjectURL(data);
      window.open(downloadURL, "_blank");
    });
  }

  // Início teste impressão Addson

  getPdfFile(recordSelectionFormula: string, arquivoRPT: string) {
    const httpOptions = {
      responseType: "blob" as "json",
    };
    let params = {
      RecordSelectionFormula: recordSelectionFormula,
      ArquivoRPT: arquivoRPT,
    };
    return this._http.post(this.REPORT, params, httpOptions).pipe(
      map((res: Blob) => {
        return res;
      })
    );
  }

  showPrinters() {
    return this._http.get("http://localhost:59148/api/impressao");
  }

  printPDF(operacao) {
    return this._http.post("http://localhost:59148/api/impressao", operacao);
  }

  // Fim teste impressão Addson

  uploadFile(file: any, ref: string, color?: string) {
    const FORMDATA = new FormData();
    FORMDATA.append("image", file, file.name);
    FORMDATA.append("referencia", ref);
    FORMDATA.append("cor", color);

    return this._http.post(this.FILES, FORMDATA);
  }

  downLoadFile(data: any, type: string, print: boolean = false) {
    let blob = new Blob([data], { type: type });
    let url = window.URL.createObjectURL(blob);
    let pwa = window.open(url + '#zoom=page-width');

    if (!pwa || pwa.closed || typeof pwa.closed == "undefined") {
      alert("Desative seu bloqueador de pop-ups e tente novamente.");
    } else if (print) {
      setTimeout(() => {
        pwa.print();
      }, 500);
    }
  }

  downLoadFileBlob(blob: Blob, print: boolean = false) {
    const url: string = window.URL.createObjectURL(blob);
    const pwa: Window = window.open(url + '#zoom=page-width');

    if (!pwa || pwa.closed || typeof pwa.closed == "undefined") {
      // Pop-up bloqueado: a aba não abriu, a object URL não será usada — revoga já.
      window.URL.revokeObjectURL(url);
      alert("Desative seu bloqueador de pop-ups e tente novamente.");
      return;
    }

    if (print) {
      setTimeout(() => pwa.print(), 500);
    }

    // Revoga a object URL após a aba já ter carregado o documento (e disparado a
    // impressão). O tempo folgado evita cortar o carregamento/print; revogar não
    // fecha a aba nem apaga o conteúdo já renderizado — o usuário segue podendo
    // imprimir/baixar manualmente pela aba aberta.
    setTimeout(() => window.URL.revokeObjectURL(url), 60_000);
  }

  downLoadFileWithName(data: any, type: string, name: string) {
    let blob = new Blob([data], { type: type });
    let url = window.URL.createObjectURL(blob);
    let element = document.createElement("a");
    element.href = URL.createObjectURL(blob);
    element.download = name;
    document.body.appendChild(element);
    element.click();

    setTimeout(() => {
      element.remove();
    }, 1000);
  }

  CNPJOrCPFValidator(control: FormControl) {
    const CPFORCPNJ = control.value;
    if (CPFORCPNJ && CPFORCPNJ !== "") {
      const convertCPFORCPNJToString = CPFORCPNJ.toString();
      if (convertCPFORCPNJToString.length >= 14) {
        return CnpjValidator.isValid(CPFORCPNJ) ? "" : { invalidCNPJ: true };
      }
      if (convertCPFORCPNJToString.length <= 11) {
        return CpfValidator.isValid(CPFORCPNJ) ? "" : { invalidCPF: true };
      }
    }
    return null;
  }

  pegarFilial(): Filial {
    const ambiente = JSON.parse(localStorage.getItem("ambiente"));

    if (!ambiente) {
      return null;
    }

    return ambiente.vendedor ? ambiente.filial : ambiente.filialUsuario;
  }

  setaParametroOcultoRedireciona(
    rota: string,
    chave: string,
    valor: string | number
  ) {
    let myMap = new Map<string, any>();
    myMap.set(chave, valor);
    //let map = new Map([[chave, valor]]);
    let extras: NavigationExtras = { state: myMap };
    this.router.navigate([rota], extras);
  }

  obtemParametroOculto(chave: string): any {
    return this.route.queryParams.pipe((data) => {
      if (this.router.getCurrentNavigation().extras.state) {
        let map = this.router.getCurrentNavigation().extras.state as Map<
          string,
          any
        >;
        if (map.has("vendaCodigo")) {
          let valor = map.get("vendaCodigo");
          return valor;
        }

        return null;
      }
    });
  }

  base64ParaBlob(base64: string, mimeType: string): Blob {
    const byteCharacters = atob(base64);
    const byteArray = new Uint8Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteArray[i] = byteCharacters.charCodeAt(i);
    }
    return new Blob([byteArray], { type: mimeType });
  }

  /** Converte um Blob em base64 puro (sem o prefixo `data:<mime>;base64,`). */
  blobParaBase64(blob: Blob): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        const resultado = reader.result as string;
        const separador = ";base64,";
        const indice = resultado.indexOf(separador);
        resolve(indice >= 0 ? resultado.substring(indice + separador.length) : resultado);
      };
      reader.onerror = () => reject(reader.error);
      reader.readAsDataURL(blob);
    });
  }

  removerAcentosECedilhas(valor: string) {
    const accentsMap: { [key: string]: string } = {
      'á': 'a', 'é': 'e', 'í': 'i', 'ó': 'o', 'ú': 'u',
      'à': 'a', 'è': 'e', 'ì': 'i', 'ò': 'o', 'ù': 'u',
      'â': 'a', 'ê': 'e', 'î': 'i', 'ô': 'o', 'û': 'u',
      'ã': 'a', 'õ': 'o', 'ñ': 'n',
      'ä': 'a', 'ë': 'e', 'ï': 'i', 'ö': 'o', 'ü': 'u',
      'ç': 'c'
    };
  
    return valor.replace(/[^\u0000-\u007E]/g, (char) => {
      return accentsMap[char] || char;
    });
  }
}
